import { MotionPathPlugin } from "gsap/dist/MotionPathPlugin.js";
import { gsap } from "gsap";
import Helper from "./Helper";
import {
  moveActions,
  drawActions,
  removeActions,
  initialStateOfArrows,
  initialStateOfPlayers,
  changeAnimationPhase,
  createAnimationSteps,
  drawStaticActions,
  addPause,
} from "./AnimationFunctions.js";

gsap.registerPlugin(MotionPathPlugin);

const MIN_DURATION_PER_PHASE = 2;

const createAnimationStepsArray = (stepsPerPhase, prefix) => {
  return stepsPerPhase.map((x) => ({
    ...x,
    steps: createAnimationSteps(x.steps),
    prefix: prefix + x.phaseId,
  }));
};

export default function createFullPlayAnimation({
  showTitle,
  prefix,
  phases,
  court,
  setSeekPos = () => {},
  setPaused = () => {},
}) {
  const createTimeline = (stepsPerPhase) => {
    let pauses = [];
    let timestamps = [];
    var timeline = gsap.timeline({
      paused: true,
      onUpdate: (x) => {
        setSeekPos(timeline.progress() * 10000);
      },
      onComplete: () => {
        setPaused(true);
      },
    });

    let animationStepsArray = createAnimationStepsArray(stepsPerPhase, prefix);

    animationStepsArray.forEach((animationStepData, index) => {
      let animationSteps = animationStepData.steps;

      initialStateOfArrows(
        animationSteps.reduce((acc, curr) => [...acc, ...curr], []),
        timeline,
        animationStepData.prefix
      );
    });

    animationStepsArray.forEach((animationStepData, index) => {
      let animationSteps = animationStepData.steps;

      let currentPhase = Helper.getCurrentPhase(
        phases,
        animationStepData.phaseId
      );

      let previousPhase = Helper.getPreviousPhase(
        phases,
        animationStepData.phaseId
      );

      initialStateOfPlayers(
        phases
          .filter((phase) => phase.id === animationStepData.phaseId)[0]
          .objects.filter((x) => x.subType === "player"),
        timeline,
        prefix
      );

      if (index === 0) {
        if (showTitle) {
          addPause(timeline, 0.1, pauses);
          /*
          timeline.to(
            {},
            {
              duration: 0.1,
            }
          );*/

          timeline.to("#title_screen", {
            opacity: 0,
            duration: 0,
          });
        }
      }

      drawStaticActions(animationStepData.prefix, timeline, animationSteps[0]);

      changeAnimationPhase(
        timeline,
        currentPhase,
        previousPhase,
        prefix,
        index === 0,
        pauses
      );

      let durationAtBeginning = timeline.duration();

      animationSteps.forEach((step, index) => {
        // first step Draw Actions (arrows / handoff sign)
        for (let subStep of step) {
          let finishedDrawingArrow = drawActions(
            animationStepData.prefix,
            timeline,
            subStep.action
          );
          timestamps.push(finishedDrawingArrow);
        }

        step.forEach((subStep, index) => {
          removeActions(
            animationStepData.prefix,
            timeline,
            subStep.action,
            index === 0,
            pauses
          );
        });

        let timestampBeforeMoving = timeline.duration();
        for (let subStep of step) {
          moveActions(
            animationStepData.prefix,
            timeline,
            subStep,
            timestampBeforeMoving,
            court
          );
        }
      });

      let durationAtEnd = timeline.duration();

      if (durationAtEnd - durationAtBeginning < MIN_DURATION_PER_PHASE) {
        addPause(
          timeline,
          MIN_DURATION_PER_PHASE - (durationAtEnd - durationAtBeginning),
          pauses
        );
      }
    });

    console.log("pauses", pauses);
    console.log(
      "sum of pauses",
      pauses.reduce((acc, curr) => acc + curr.duration, 0)
    );
    return { timeline, timestamps, pauses };
  };

  let stepsPerPhase = [];
  for (let phase of phases) {
    stepsPerPhase.push({
      phaseId: phase.id,
      steps: Helper.calculateNextPhase(phase, court).steps,
    });
  }

  return createTimeline(stepsPerPhase);
}
